import { IsArray, IsDefined, IsNumber, IsOptional } from 'class-validator';

export class GetRecipeInformationLiveDto {
  @IsDefined()
  @IsArray()
  @IsNumber({}, { each: true })
  stockIds: number[];

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  recipeIds: number[];
}
